import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=7d33c8bb&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=js"
export * from "./ShoppingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33c8bb",
  null
  
)

export default component.exports